import { BaseDto } from "src/dtos/common/baseDto";

// BOM 검토 그리드
export interface PRD2040_R01BomDto extends BaseDto {
    childItemcd: string;
    itemNm: string;
    itemSpec: string;
    locationCd?: string;
    locationNm?: string;
    mountQty: number;
    bomQty: number;
    diffQty: number;
    isMismatch: boolean;

    inserted: boolean;
    isModified: boolean;
}

// 실장좌표 검토 그리드
export interface PRD2040_R01MountDto extends BaseDto {
    topBottom: string;
    coordinateCd: string;
    
    // 비교품목(신규) 정보
    mountItemCd: string;
    mountItemNm: string;
    
    // 지시품목(기존) 정보
    bomItemCd: string;
    bomItemNm: string;
    
    // 지시품목 기준 좌표값
    xcoordinate: number;
    ycoordinate: number;
    orient: number;
    
    // 비교 결과
    changeType: string;

    inserted: boolean;
    isModified: boolean;
}

export const defaultPRD2040_R01BomDto: PRD2040_R01BomDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    childItemcd: '',
    itemNm: '',
    itemSpec: '',
    locationCd: '',
    locationNm: '',
    mountQty: 0,
    bomQty: 0,
    diffQty: 0,
    isMismatch: false,
    inserted: false,
    isModified: false
};

export const defaultPRD2040_R01MountDto: PRD2040_R01MountDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    topBottom: '',
    coordinateCd: '',
    mountItemCd: '',
    mountItemNm: '',
    bomItemCd: '',
    bomItemNm: '',
    xcoordinate: 0,
    ycoordinate: 0,
    orient: 0,
    changeType: '',
    inserted: false,
    isModified: false
};
